export default __webpack_public_path__ + "static/texture-781e63a3fc72aa1de9302bea5a3b40c2.svg";